import {codeScanningAlertPath} from '@github-ui/paths'
import {ShieldCheckIcon, ShieldIcon, ShieldSlashIcon} from '@primer/octicons-react'
import {ActionList} from '@primer/react'

import styles from './SecurityAlert.module.css'

export type SecurityAlert = {
  number: number
  status: 'DISMISSED' | 'FIXED' | 'OPEN'
  repository: {
    nameWithOwner: string
  }
  title: string
}

type SecurityAlertProps = {
  onLinkClick?: (event: MouseEvent) => void
  securityAlert: SecurityAlert
}

export function SecurityAlert({onLinkClick, securityAlert}: SecurityAlertProps) {
  const [owner, repo] = securityAlert.repository?.nameWithOwner.split('/') || []

  if (!owner || !repo) {
    return null
  }

  const renderIcon = () => {
    switch (securityAlert.status) {
      case 'FIXED':
        return <ShieldCheckIcon className="fgColor-done" />
      case 'OPEN':
        return <ShieldIcon className="fgColor-open" />
      case 'DISMISSED':
        return <ShieldSlashIcon className="fgColor-closed" />
      default:
        return <ShieldIcon className="fgColor-open" />
    }
  }

  return (
    <ActionList.LinkItem
      href={codeScanningAlertPath({
        owner,
        repo,
        alertNumber: securityAlert.number,
      })}
      target="_blank"
      onClick={
        onLinkClick
          ? (event: React.MouseEvent<HTMLElement>) => {
              onLinkClick(event.nativeEvent)
            }
          : undefined
      }
    >
      <ActionList.LeadingVisual>{renderIcon()}</ActionList.LeadingVisual>
      <div className={styles.alertTitle}>{securityAlert.title}</div>
      <ActionList.TrailingVisual>{`#${securityAlert.number}`}</ActionList.TrailingVisual>
    </ActionList.LinkItem>
  )
}
